import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

import { JobBoardPosting } from '@recruitee/job-boards-types';

import {
  JobBoardLastPostingActions,
  JobBoardLastPostingSelectors,
} from './job-board-last-posting.store';

@Injectable({ providedIn: 'root' })
export class JobBoardLastPostingStoreService {
  private readonly store = inject(Store);

  public getJobBoardLastPostig(jobBoardCodename: string): Observable<JobBoardPosting | null> {
    return this.store.select(JobBoardLastPostingSelectors.byId(jobBoardCodename));
  }

  public fetchJobBoardsLastPosting(jobBoardCodename: string): void {
    this.store.dispatch(JobBoardLastPostingActions.fetchOne({ payload: { id: jobBoardCodename } }));
  }
}
